import { Navigate, useLocation } from 'react-router-dom';
import { isCustomerAuthenticated } from '../lib/session';

export default function CustomerProtectedRoute({ children }) {
  const location = useLocation();

  if (!isCustomerAuthenticated()) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/account/auth?next=${next}`} replace />;
  }

  return children;
}
